import type { LocationData } from '../types';

// Coordinates from the live villaspilia.gr (Stavros, Ithaca)
export const locationsData: LocationData[] = [
  {
    name: 'Villa Spilia',
    latitude: 38.442109,
    longitude: 20.645534,
    description:
      'Our apartments sit in Stavros, the main village of northern Ithaca, with panoramic views toward the Ionian Sea.',
  },
];

export function getPropertyLocation(): LocationData {
  return locationsData[0]!;
}
export function getNearbyLocations(): LocationData[] {
  return locationsData.slice(1);
}
export function getAllLocations(): LocationData[] {
  return locationsData;
}

export const locationContent = {
  address: 'Stavros, Ithaki, Greece 28300',
  phone: '+30 694 854 6054',
  email: 'info@villaspilia.gr',
  directionsUrl:
    'https://www.google.com/maps/dir/Current+Location/38.442109,20.645534',
  gettingHere: {
    byFerry:
      'Reach Ithaca by ferry from Kefalonia (Sami) or Patras. Frikes port is just 2 km away; Pisaetos and Vathy ports are about 15 km (20 min by car).',
    byAir:
      'Fly into Kefalonia (EFL). From the airport, drive to Sami port and take the ferry to Ithaca.',
    byCar:
      'Free parking at the property. Ithaca roads are scenic and narrow — drive gently and enjoy the view.',
  },
  nearbyAttractions: [
    { name: 'Frikes Village', distance: '2 km · 5 min drive', description: 'A small fishing harbour with waterfront tavernas and daily ferry connections.' },
    { name: 'Kioni Village', distance: '6 km · 15 min drive', description: 'A postcard-perfect harbour cradled into the hillside, beloved by yachters.' },
    { name: 'Polis Bay & Cave of the Nymphs', distance: '3 km · 8 min drive', description: 'A quiet pebble beach and the mythical cave from Homer\'s Odyssey.' },
    { name: 'Archaeological Museum of Stavros', distance: '300 m · 5 min walk', description: 'Local finds suggesting Stavros as the seat of Odysseus.' },
  ],
};
